import {useEffect} from 'react';
export const COLOR = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  TERTIARY: 'tertiary'
};
export const COLOR_CODE = {
  _D0D0D0: '#D0D0D0',
  _3387DF: '#3387DF',
  _DFDFDF: '#DFDFDF',
  _333333: '#333333',
  _4E4E4E: '#4E4E4E',
  _FFFFFF: '#FFFFFF',
  _1D1D1D: '#1D1D1D',
  _EFEFEF: '#EFEFEF',
  _616161: '#616161',
  _3A3A3A: '#3A3A3A',
  _d20000: '#d20000',
  _131313: '#131313',
  _818181: '#818181',
  _94D6F0: '#94D6F0',
  _000000: '#000000',
  _232323: '#232323',
  _383838: '#383838',
  _0073E6: '#0073E6',
  _00152B: '#00152B',
  _DB3333: '#DB3333',
  _CCEBF9: '#CCEBF9',
  _007EB5: '#007EB5',
  _0069D7: '#0069D7',
  _001A10: '#001A10',
  _008251: '#008251',
  _66B497: '#66B497',
  _2A0000: '#2A0000',
  _E46666: '#E46666',
  _CC6200: '#CC6200',
  _FF9533: '#FF9533',
  _272727: '#272727',
  _DADADA: '#DADADA',
  _331800: '#331800',
  _D6AC16: '#D6AC16'
};
export const useSetCSSVariables = () => {
  useEffect(() => {
    if (typeof document !== 'undefined') {
      Object.entries(COLOR_CODE).forEach(([key, value]) => {
        document.documentElement.style.setProperty(`--color${key}`, value);
      });
    }
  }, []);
};
export const TAG_COLOR = {
  CYAN_500: 'Cyan-500',
  CYAN_700: 'Cyan-700',
  GRAY_100: 'Gray-100',
  GRAY_500: 'Gray-500',
  GREEN_150: 'Green-150',
  GREEN_600: 'Green-600',
  ORANGE_150: 'Orange-150',
  ORANGE_400: 'Orange-400',
  RED_150: 'Red-150',
  RED_600: 'Red-600',
  YELLOW_150: 'Yellow-150',
  YELLOW_400: 'Yellow-400',
  AUXILIARY_300: 'Auxiliary-300',
  AUXILIARY_600: 'Auxiliary-600'
};
